import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { CompanyUserConstant } from 'src/app/constants/label-constants';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
import { DeleteDialogboxComponent } from '../delete-dialogbox/delete-dialogbox.component';
import { StatusDialogboxComponent } from '../status-dialogbox/status-dialogbox.component';
import { CompanyUserAddEditComponent } from './company-user-add-edit/company-user-add-edit.component';
import { CompanyUserViewComponent } from './company-user-view/company-user-view.component';
import { CompanyUserModel } from 'src/app/models/companyUserModel';

@Component({
  selector: 'app-company-user',
  templateUrl: './company-user.component.html',
  styleUrls: ['./company-user.component.scss']
})
export class CompanyUserComponent {
  CompanyUserList: any = [];
  showData: boolean = false;
  enterSearch: string = '';
  searchClose: boolean = false;
  SortColumn: any = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['rowNumber', 'firstName', 'lastName', 'CompanyName', 'EmailId', 'MobileNo', 'isActive', 'Action'];
  dataSource: MatTableDataSource<CompanyUserModel> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  companyUserConstant: any = [];
  commonConstant: any = [];
  NoRecordFound: any = [];
  CompanyUserDeleteObj: any = {};
  companyUserStatusObj: any = {};

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.commonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.companyUserConstant = CompanyUserConstant;
    this.getCompanyUserList();
    this.sharedService.setData('Company User');
  }

  getCompanyUserList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.companyUser.GetCompanyUserList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.CompanyUserList = response.data;
          this.dataSource.data = this.CompanyUserList;
          if (this.CompanyUserList.length > 0) {
            TotalRecords = this.CompanyUserList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  SortChange(event) {
    this.sortDirection = event.direction ? event.direction : 'asc';
    this.SortColumn = event.active;
    this.getCompanyUserList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getCompanyUserList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getCompanyUserList();
      this.searchClose = true;
    }
  }

  pageChanged(event) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getCompanyUserList();
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getCompanyUserList();
    this.searchClose = false;
  }

  Deletepopup(companyUserId: number, companyUserName: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.CompanyUserDeleteObj = {
      userId: companyUserId,
      firstName: companyUserName,
      element: 'compnay user'
    }
    modalRef.componentInstance.CompanyUserDeleteObj = this.CompanyUserDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.getCompanyUserList();
      }
    }).catch((error) => {
    });
  }

  CompanyUserListDetail(companyUserId: number) {
    const modalRef = this.modalService.open(CompanyUserViewComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.userId = companyUserId;
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }

  AddCompanyUser(companyUserId: number) {
    const modalRef = this.modalService.open(CompanyUserAddEditComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.userId = companyUserId;
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getCompanyUserList();
      }
    }).catch((error) => {
    });
  }

  onStatus(companyUserId: number, companyUserName: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.companyUserStatusObj = {
      userId: companyUserId,
      userName: companyUserName,
      activeUser: active
    }
    modalRef.componentInstance.companyUserStatusObj = this.companyUserStatusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.CompanyUserList.forEach((element: { userId: number; isActive: boolean; }) => {
          if (element.userId == companyUserId) {
            element.isActive = active ? false : true
            this.getCompanyUserList()
          }
        });
      }
    }).catch((error) => {
    });
  }
}
